// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fksc2QFOlnsEKwR0Dyya {
  /* height: calc(95vh - 125px);
  margin: 10px 20px 0 80px; */
  /* background-color: #f4f7fc; */
  /* padding: 20px; */
  height: calc(100vh - 140px);
  overflow: auto;
  padding-top: 15px;
  margin: 0px 20px 0px 30px;
}

.OdsBe4VD0toptdCm1ILj button {
  width: 150px;
  height: 40px;
  padding: 8px;
  margin-right: 10px;
}

.pxffI2_MpCNWax_jI2Lp {
  overflow-y: auto;
}

.fIXXAgejIcqMUnO2oQPV {
  display: none;
}

.OdsBe4VD0toptdCm1ILj {
  float: right;
  padding-right: 14px;
  margin-top: 14px;
}

.CMW62A8PAQPd9TRNLd6H {
  height: 100vh;
  overflow-y: auto;
  margin: 0px 0px 0 40px;
}

.CMW62A8PAQPd9TRNLd6H::-webkit-scrollbar {
  width: 3px;
}

.CMW62A8PAQPd9TRNLd6H::-webkit-scrollbar-thumb {
  background-color: gray;
}

.Z9bMqgKrBsjstAR7j7h9::-webkit-scrollbar {
  width: 5px;
}

.Z9bMqgKrBsjstAR7j7h9::-webkit-scrollbar-thumb {
  background-color: gray;
}

.sSTfiNxSD8z8jkGy3iB5 {
  text-align: left;
  margin-left: 10px;
  margin-top: 15px;
}

.bIKw91qGpWF_4TXwF5DL {
  font-weight: 500;
}

.yDzXXixfi71WG2QfVJ3D {
  width: "5%";
}

.LPy4zJPRLY0HlaUSpAqJ {
  height: 100%;
  float: left;
  width: 100%;
  text-align: justify;
  background-color: white;
  row-gap: 20px;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 1px #969696;
}

.LPy4zJPRLY0HlaUSpAqJ h3 {
  margin-left: 20px;
  padding-top: 15px;
}

.Z9bMqgKrBsjstAR7j7h9 h3 {
  text-align: left;
  margin-left: 10px;
  padding-top: 15px;
  background-color: white;
  width: 59%;
}

.Z9bMqgKrBsjstAR7j7h9 {
  box-shadow: 0px 1px 2px 1px #969696;
  width: 100%;
  float: right;
  min-height: 300px;
  background-color: white;
  border-radius: 10px;
  overflow-y: auto;
  max-height: 94%;
  height: 100%;
}

.NmcaQoFrXyb2QfWXHLw6 {
  position: relative;
  padding-bottom: 10px;
  margin-left: 10px;
}

.OdsBe4VD0toptdCm1ILj button {
  width: 150px;
  height: 40px;
  padding: 20px 10px;
  margin-right: 10px;
}

.ZypXbSBQ3nEN2M1Ps09E h1 {
  overflow-y: auto;
  float: left;
  position: fixed;
  background-color: white;
  display: flex;
  padding-top: 20px;
  padding-right: 100%;
  padding-left: 8px;
}

.NmcaQoFrXyb2QfWXHLw6 span {
  position: absolute;
  left: 50%;
  font-weight: 600;
}

.pxffI2_MpCNWax_jI2Lp {
  padding-bottom: 30px;
}

.NmcaQoFrXyb2QfWXHLw6 {
  margin-left: 20px;
  padding-top: 15px;
}

@media only screen and (max-width: 778px) {
  .ZypXbSBQ3nEN2M1Ps09E h1 {
    font-size: 17px;
    font-weight: 500;
    margin-top: -20px;
    margin-bottom: 26px;
    text-transform: uppercase;
    text-align: left;
    padding-left: 36px;
  }
  .ZypXbSBQ3nEN2M1Ps09E {
    position: fixed;
    justify-content: center;
    width: 100%;
    height: 48px;
    display: block;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    background-color: white;
  }
  .fIXXAgejIcqMUnO2oQPV {
    display: flex;
    background-color: white;
  }
  .uxkWJKbYHJkSEPT1OUlR {
    background-color: white;
  }
  .fksc2QFOlnsEKwR0Dyya {
    margin: 0px;
  }
  .CMW62A8PAQPd9TRNLd6H {
    margin: 0px 0px 0 0px;
    overflow: auto;
    height: 100%;
    font-size: 13px;
  }
  .OdsBe4VD0toptdCm1ILj {
    float: right;
    margin-bottom: 10px;
    margin-top: 5px;
    font-size: 9px;
    width: 106px;
  }
}`, "",{"version":3,"sources":["webpack://./components/Alerts/Alerts.module.css"],"names":[],"mappings":"AAAA;EACE;6BAAA;EAEA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;AACF;;AACA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAEF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;AAKF;;AAFA;EACE,UAAA;AAKF;;AAFA;EACE,sBAAA;AAKF;;AAFA;EACE,UAAA;AAKF;;AAFA;EACE,sBAAA;AAKF;;AAFA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,WAAA;AAMF;;AAJA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAOF;;AAJA;EACE,iBAAA;EACA,iBAAA;AAOF;;AAJA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,UAAA;AAOF;;AAJA;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAOF;;AAJA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;AAOF;;AALA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAQF;;AALA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAQF;;AALA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AAQF;;AALA;EACE,oBAAA;AAQF;;AALA;EACE,iBAAA;EACA,iBAAA;AAQF;;AALA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,gBAAA;IACA,kBAAA;EAQF;EANA;IACE,eAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,+GACE;IAGF,uBAAA;EAKF;EAHA;IACE,aAAA;IACA,uBAAA;EAKF;EAHA;IACE,uBAAA;EAKF;EAHA;IACE,WAAA;EAKF;EAHA;IACE,qBAAA;IACA,cAAA;IACA,YAAA;IACA,eAAA;EAKF;EAHA;IACE,YAAA;IACA,mBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EAKF;AACF","sourcesContent":[".alerts {\n  /* height: calc(95vh - 125px);\n  margin: 10px 20px 0 80px; */\n  /* background-color: #f4f7fc; */\n  /* padding: 20px; */\n  height: calc(100vh - 140px);\n  overflow: auto;\n  padding-top: 15px;\n  margin: 0px 20px 0px 30px;\n}\n.addHookButton button {\n  width: 150px;\n  height: 40px;\n  padding: 8px;\n  margin-right: 10px;\n}\n.scrollclass {\n  overflow-y: auto;\n}\n.hamburger {\n  display: none;\n}\n.addHookButton {\n  float: right;\n  padding-right: 14px;\n  margin-top: 14px;\n}\n\n.noti {\n  height: (100vh);\n  overflow-y: auto;\n  margin: 0px 0px 0 40px;\n}\n\n.noti::-webkit-scrollbar {\n  width: 3px;\n}\n\n.noti::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.rightDiv::-webkit-scrollbar {\n  width: 5px;\n}\n\n.rightDiv::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.alert {\n  text-align: left;\n  margin-left: 10px;\n  margin-top: 15px;\n}\n\n.alertMsg {\n  font-weight: 500;\n}\n.alertService {\n  width: '5%';\n}\n.leftDiv {\n  height: 100%;\n  float: left;\n  width: 100%;\n  text-align: justify;\n  background-color: white;\n  row-gap: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 1px 2px 1px #969696;\n}\n\n.leftDiv h3 {\n  margin-left: 20px;\n  padding-top: 15px;\n}\n\n.rightDiv h3 {\n  text-align: left;\n  margin-left: 10px;\n  padding-top: 15px;\n  background-color: white;\n  width: 59%;\n}\n\n.rightDiv {\n  box-shadow: 0px 1px 2px 1px #969696;\n  width: 100%;\n  float: right;\n  min-height: 300px;\n  background-color: white;\n  border-radius: 10px;\n  overflow-y: auto;\n  max-height: 94%;\n  height: 100%;\n}\n\n.common {\n  position: relative;\n  padding-bottom: 10px;\n  margin-left: 10px;\n}\n.addHookButton button {\n  width: 150px;\n  height: 40px;\n  padding: 20px 10px;\n  margin-right: 10px;\n}\n\n.notifications h1 {\n  overflow-y: auto;\n  float: left;\n  position: fixed;\n  background-color: white;\n  display: flex;\n  padding-top: 20px;\n  padding-right: 100%;\n  padding-left: 8px;\n}\n\n.common span {\n  position: absolute;\n  left: 50%;\n  font-weight: 600;\n}\n\n.scrollclass {\n  padding-bottom: 30px;\n}\n\n.common {\n  margin-left: 20px;\n  padding-top: 15px;\n}\n\n@media only screen and (max-width: 778px) {\n  .notifications h1 {\n    font-size: 17px;\n    font-weight: 500;\n    margin-top: -20px;\n    margin-bottom: 26px;\n    text-transform: uppercase;\n    text-align: left;\n    padding-left: 36px;\n  }\n  .notifications {\n    position: fixed;\n    justify-content: center;\n    width: 100%;\n    height: 48px;\n    display: block;\n    box-shadow:\n      0 2px 2px 0 rgb(0 0 0 / 14%),\n      0 3px 1px -2px rgb(0 0 0 / 12%),\n      0 1px 5px 0 rgb(0 0 0 / 20%);\n    background-color: white;\n  }\n  .hamburger {\n    display: flex;\n    background-color: white;\n  }\n  .notificaation_hamburger {\n    background-color: white;\n  }\n  .alerts {\n    margin: 0px;\n  }\n  .noti {\n    margin: 0px 0px 0 0px;\n    overflow: auto;\n    height: 100%;\n    font-size: 13px;\n  }\n  .addHookButton {\n    float: right;\n    margin-bottom: 10px;\n    margin-top: 5px;\n    font-size: 9px;\n    width: 106px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alerts": `fksc2QFOlnsEKwR0Dyya`,
	"addHookButton": `OdsBe4VD0toptdCm1ILj`,
	"scrollclass": `pxffI2_MpCNWax_jI2Lp`,
	"hamburger": `fIXXAgejIcqMUnO2oQPV`,
	"noti": `CMW62A8PAQPd9TRNLd6H`,
	"rightDiv": `Z9bMqgKrBsjstAR7j7h9`,
	"alert": `sSTfiNxSD8z8jkGy3iB5`,
	"alertMsg": `bIKw91qGpWF_4TXwF5DL`,
	"alertService": `yDzXXixfi71WG2QfVJ3D`,
	"leftDiv": `LPy4zJPRLY0HlaUSpAqJ`,
	"common": `NmcaQoFrXyb2QfWXHLw6`,
	"notifications": `ZypXbSBQ3nEN2M1Ps09E`,
	"notificaation_hamburger": `uxkWJKbYHJkSEPT1OUlR`
};
export default ___CSS_LOADER_EXPORT___;
